import React from 'react';

const score = value => value != null && Number.isFinite(Number(value)) ? `${Number(value).toFixed(1)}%` : 'Not measured';

/** Readiness and measured accuracy are separate: passing checks is not a forecast guarantee. */
export default function BudgetReadiness({ data }) {
  const { convergence, backtest, demand } = data;
  if (!convergence && !backtest && !demand) return null;
  const failedGates = (convergence?.gates || []).filter(gate => gate.pass === false);
  const blocked = convergence?.converged === false || (data.reconciliation?.blocking?.length || 0) > 0;
  const corrections = convergence?.corrections || [];
  const unresolved = convergence?.unresolved || [];
  return (
    <section className="ob-readiness" aria-label="Budget readiness">
      <strong>{blocked ? 'Needs review before applying' : failedGates.length ? 'Checks passed with assumptions to review' : convergence?.converged ? 'Reconciliation checks passed' : 'Budget evidence'}</strong>
      <p>Historical accuracy describes past performance; it does not guarantee this budget.</p>
      {backtest && (
        <dl className="ob-accuracy">
          <div><dt>Rooms historical error</dt><dd>{score(backtest.rooms?.scores?.demand?.revenueWape)}</dd></div>
          <div><dt>Operating-account historical error</dt><dd>{score(backtest.expenses?.overallWapePct)}</dd></div>
          <div><dt>Accounts tested</dt><dd>{backtest.expenses?.scoredAccounts ?? 0} tested · {backtest.expenses?.unscoredAccounts ?? 0} untested</dd></div>
        </dl>
      )}
      {backtest && <p>Lower error is better. Rooms uses a historical replay; operating-account methods use their available holdout tests.</p>}
      {failedGates.length > 0 && <ul>{failedGates.map(gate => <li key={gate.gate}>{gate.summary}</li>)}</ul>}
      {unresolved.length > 0 && (
        <details><summary>{unresolved.length} unresolved finding{unresolved.length === 1 ? '' : 's'}</summary>
          <ul>{unresolved.map((item, index) => <li key={index}>{item.summary}{item.why ? ` — ${item.why}` : ''}</li>)}</ul>
        </details>
      )}
      {corrections.length > 0 && (
        <details><summary>{corrections.length} adjustment{corrections.length === 1 ? '' : 's'} made during reconciliation</summary>
          <ul>{corrections.map((item, index) => <li key={index}>{item.department || item.account || 'Budget'}: {item.reason}</li>)}</ul>
        </details>
      )}
      {demand?.growthOverride && (
        <details><summary>Rooms growth assumptions</summary>
          <p>Room nights: {demand.growthOverride.roomNightsGrowthPct}% beyond trend. ADR: {demand.growthOverride.adrGrowthPct}% beyond trend.</p>
          <p>{demand.growthOverride.rationale}</p>
        </details>
      )}
    </section>
  );
}
